import { capitalize } from "lodash";

import { Pill } from "src/base-components/Pill";
import { FeatureQueryStatus } from "src/clients/features-control";
import { FeatureQueryEnvironmentSetting } from "src/clients/features-control";
import { useEnvironment } from "src/eventsCatalogue/useEnvironment";

export const QueryStatusPill: React.FC<{
  statuses: Record<string, FeatureQueryEnvironmentSetting>;
}> = ({ statuses }) => {
  const [environment] = useEnvironment();

  return (
    <Pill
      size="sm"
      variant={
        statuses[environment].status === FeatureQueryStatus.ACTIVE
          ? "green"
          : "gray"
      }
    >
      {capitalize(statuses[environment].status)}
    </Pill>
  );
};
